module.exports = __webpack_public_path__ + "static/img/2.f999b8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/banner3/2.png
// module id = gj6v
// module chunks = 14